import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Divider,
  Grid,
  Typography,
  CircularProgress,
  Icon,
} from "@mui/material";
import { useState } from "react";
import axios from "axios.js";
import { useAwaitDialog } from "app/components/status_dialog";
import QRCode from "react-qr-code";

function PaymentInstrumentDialog({ paymentDetails }) {
  const statusDialog = useAwaitDialog();
  const [showInlineLoading, setShowInlineLoading] = useState(false);

  async function checkPayment() {
    setShowInlineLoading(true);
    await axios
      .get(
        `/data_capture/payments/${paymentDetails.reference}/status.json`,
      )
      .then(async (result) => {
        setShowInlineLoading(false);
        if (result.data.status === "success") {
          // console.log(result.data.data);
          if (result.data.data.status === "success") {
            await statusDialog.show(result.data.data.message, "success");
            window.location.reload();
          } else {
            await statusDialog.show(result.data.data.message, "warning");
          }
        } else {
          await statusDialog.show(result.data.data.message, "error");
        }
      })
      .catch(async () => {
        setShowInlineLoading(false);
        await statusDialog.show(
          "An unexpected error occurred. Please try again later.",
          "error",
        );
      });
  }

  return (
    <Dialog open fullWidth maxWidth="sm">
      <DialogContent>
        <Box p={1}>
          <Box align="center">
            <Box>
              <Typography variant="h4" fontWeight="light">
                {paymentDetails.caption}
              </Typography>
              <Typography mt={1} variant="h3" fontWeight="medium">
                <small>{paymentDetails.currency}</small>
                {(paymentDetails.debit_amount / 100).toLocaleString("en", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
                {paymentDetails.debit_amount > paymentDetails.amount && (
                  <Typography fontSize={14} fontWeight="light">{`${
                    paymentDetails.currency
                  }${(paymentDetails.fee / 100).toLocaleString("en", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })} fee incl.`}</Typography>
                )}
              </Typography>
            </Box>
            {paymentDetails.type === "display" ? (
              <Box>
                <Box mt={1} align="center" mb={3}>
                  <Typography variant="h6" fontWeight="regular">
                    {paymentDetails.instructions}
                  </Typography>
                </Box>
                <Divider />
                <Box mt={2} mb={2} align="center">
                  {paymentDetails.instrument.map((record) => (
                    <Grid container spacing={0}>
                      <Grid item xs={6} md={6} lg={6}>
                        <Box align="left">
                          <Typography
                            variant="h6"
                            fontWeight="light"
                            fontSize={18}
                          >
                            <b>{record.key}:</b>
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={6} md={6} lg={6}>
                        <Box align="right">
                          <Typography
                            variant="h6"
                            fontWeight="light"
                            fontSize={18}
                          >
                            {record.value}
                          </Typography>
                        </Box>
                      </Grid>
                    </Grid>
                  ))}
                </Box>
                <Divider />
                <Box mt={3} align="center">
                  <Typography variant="h6" fontWeight="bold" color="error">
                    {paymentDetails.notes}
                  </Typography>
                </Box>
              </Box>
            ) : (
              <Box>
                <Box mt={2} align="center" mb={3}>
                  <Typography variant="h6" fontWeight="regular" fontSize={17}>
                    {paymentDetails.instructions}
                  </Typography>
                </Box>
                <Box>
                  <QRCode
                    value={
                      paymentDetails.instrument.redirect_url != null
                        ? paymentDetails.instrument.redirect_url
                        : ""
                    }
                    size={180}
                  />
                </Box>
                <Box mt={3}>
                  <Button
                    onClick={() => {
                      window
                        .open(paymentDetails.instrument.redirect_url, "_blank")
                        .focus();
                    }}
                    color="success"
                    variant="contained"
                    startIcon={<Icon>payment</Icon>}
                  >
                    Pay Now
                  </Button>
                </Box>
              </Box>
            )}
            <Box mt={5}>
              {showInlineLoading && (
                <Box mb={3}>
                  <Typography mb={1} fontSize={12}>
                    Checking payment status...
                  </Typography>
                  <CircularProgress color="info" />
                </Box>
              )}
              <Button
                variant="outlined"
                fullWidth
                startIcon={<Icon>sync</Icon>}
                sx={{
                  height: 44,
                  borderColor: "#424242",
                  color: "#424242",
                  borderRadius: 1,
                  textTransform: "none",
                  fontWeight: 500,
                  "&:hover": {
                    borderColor: "#212121",
                    backgroundColor: "rgba(0,0,0,0.03)",
                  },
                }}
                onClick={() => {
                  checkPayment(paymentDetails.reference);
                }}
              >
                Check Payment
              </Button>

              <Box
                mt={3}
                onClick={() => {
                  if (
                    window.confirm(
                      "Are you sure you want to cancel this transaction?",
                    ) === true
                  ) {
                    window.location.reload();
                  }
                }}
              >
                <Typography variant="h6" fontWeight="light">
                  [ x cancel ]
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default PaymentInstrumentDialog;
